import { Lock } from "lucide-react";
import { useState } from "react";

import { Button } from "@krea/shared/design-system/Button";

import { EnquireAboutAttractivenessModal } from "./enquire-about-attractiveness-modal";

const OfferAttractivenessLocked = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleEnquireClick = () => {
    setModalOpen(true);
  };

  return (
    <>
      <div className={"relative space-y-2"}>
        <div className="mb-1 flex items-center justify-between">
          <h2 className="flex items-center text-section">
            <Lock className="mr-2 size-5 text-primary" />
            Unlock Offer Attractiveness
          </h2>
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <div>
            <p className="mt-1 text-sm leading-relaxed text-gray-600">
              Would you like to know how attractive your offer is to customers
              and how likely it is to convert? Get recommendations to win more
              deals.
            </p>
          </div>
          <div>
            <Button
              size="default"
              className="text-base"
              onClick={handleEnquireClick}
              variant="secondary"
            >
              Enquire About Access
            </Button>
          </div>
        </div>
      </div>
      <EnquireAboutAttractivenessModal
        open={modalOpen}
        setOpen={setModalOpen}
      />
    </>
  );
};

export { OfferAttractivenessLocked };
